<template>

  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="昵称">
          <el-input v-model="formInline.search" placeholder="请输入昵称" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户id">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="请选择">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待审核" value="0"></el-option>
            <el-option label="已通过" value="1"></el-option>
            <el-option label="拒绝" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台">
          <el-select v-model="formInline.plantform_id" placeholder="请选择" clearable>
            <el-option label="全部" value="0"></el-option>
            <el-option :label="item.name" :value="item.plantform_id" v-for="item in plantform" :key="item.plantform_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.value1" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="60"></el-table-column>
          <el-table-column prop="nickName" label="微信头像" width="70">
            <template slot-scope="scope">
              <img v-img-url="scope.row.user.avatarUrl" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="" label="昵称">
            <template slot-scope="scope">
              <span>{{scope.row.user.nickName}}</span>
              <span class="gray9">(用户ID：{{scope.row.user.user_id}})</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_no" label="订单号"></el-table-column>
           <el-table-column prop="plantform_id" label="平台">
            <template slot-scope="scope">
              <span >{{scope.row.plantform.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <div class="d-s-c">
                <el-tag v-if="scope.row.status == 0" >待审核</el-tag>
                <el-tag v-if="scope.row.status == 1" type="success" class="green">已通过</el-tag>
                <el-tag v-if="scope.row.status == 2" type="info" class="green">已拒绝</el-tag>
              </div>
              <div  v-if="scope.row.status == 2">{{scope.row.reject_reason}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column prop="order_price" label="订单金额"></el-table-column>
          <el-table-column prop="points" label="兑换积分"></el-table-column>
         
          <el-table-column prop="create_time" label="申请时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button  v-if="scope.row.status == 0" @click="editClick(scope.row)" type="text" size="small">
                  审核
                </el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="dataModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
  import PointsApi from '@/api/points.js';
  import Edit from './dialog/Edit.vue';
  export default {
    components: {
      /*编辑组件*/
      Edit
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        plantform: [],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          search: '',
          plantform_id: '',
          status: '-1',
          user_id: '',
          value1: ''
        },
         open_edit: false,
         dataModel:{}
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        PointsApi.getExchangeList(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.plantform = data.data.plantform;
        }).catch(error => {

        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getTableList();
      },
      /*删除*/
      delClick: function(row) {
        let self = this;
        self.loading = true;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {

          //请求接口
          PointsApi.exchangedel({
            id: row.id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getTableList();
          }).catch(() =>{
            self.loading = false;
          });
        }).catch(() =>{
          self.loading = false;
        });
      },

     
      //编辑
      editClick($row){
        this.dataModel = $row;
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      },
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/points/part/Exchange.vue